export const CREATE_STAGE_BY_NUMBER = 'sagas/stage/CREATE_STAGE_BY_NUMBER';
export const GET_STAGE_BY_NUMBER = 'sagas/stage/GET_STAGE_BY_NUMBER';
